import { create } from 'zustand';
import { environment } from '@/config/environment';
import { clamp } from '@/utils/math';

type TapPayload = {
  reward?: boolean;
};

type GameStore = {
  sceneReady: boolean;
  status: string;
  energy: number;
  combo: number;
  tapCount: number;
  activeTouches: number;
  audioEnabled: boolean;
  platformLabel: string;
  appVersion: string;
  setSceneReady: (ready: boolean) => void;
  setStatus: (status: string) => void;
  setActiveTouches: (count: number) => void;
  registerTap: (payload?: TapPayload) => void;
  resetCombo: () => void;
  toggleAudio: () => void;
  setPlatformLabel: (label: string) => void;
};

export const useGameStore = create<GameStore>((set) => ({
  sceneReady: false,
  status: 'Inicializando runtime',
  energy: 18,
  combo: 0,
  tapCount: 0,
  activeTouches: 0,
  audioEnabled: true,
  platformLabel: 'web',
  appVersion: environment.appVersion,
  setSceneReady: (ready) => set({ sceneReady: ready }),
  setStatus: (status) => set({ status }),
  setActiveTouches: (count) => set({ activeTouches: count }),
  registerTap: ({ reward = false } = {}) =>
    set((state) => ({
      tapCount: state.tapCount + 1,
      combo: reward ? state.combo + 1 : Math.max(state.combo, 1),
      energy: clamp(state.energy + (reward ? 12 : 3), 0, 100),
      status: reward ? 'Reaccion premium activada' : 'Tap detectado',
    })),
  resetCombo: () => set({ combo: 0 }),
  toggleAudio: () => set((state) => ({ audioEnabled: !state.audioEnabled })),
  setPlatformLabel: (label) => set({ platformLabel: label }),
}));
